import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MsgState } from './flagReminderMsg.state';

export const getFlagReminderMsgState = createFeatureSelector<MsgState>('flagReminderMsg');

export const getFlagReminderMsg = createSelector(
  getFlagReminderMsgState,
  (state) => state.flagReminderMsg
);
